import { registerComponent, createMessage } from "helpers";

import { WYATTElement } from "wyatt";

registerComponent(
  "wyatt-share",
  class WyattShare extends WYATTElement {
    constructor() {
      super();

      this.button = this.querySelector("button");
      this.button.addEventListener("click", this.copyToClipboard.bind(this));
    }

    async copyToClipboard() {
      await window.navigator.clipboard.writeText(this.config.url);

      createMessage(this.config.successMessage, { type: "success" });
      this.close();
    }
  }
);
